<script>
export default {
  props: {
    value: {
      type: Boolean,
    },
    label: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
<template>
  <ElCheckbox
    :value="value"
    class="f-c-check"
    :disabled="disabled"
    @input="$emit('input', $event)"
    @change="$emit('change', $event)"
    @focus="$emit('focus', $event)"
    @blur="$emit('blur', $event)"
  >
    <slot>{{label}}</slot>
  </ElCheckbox>
</template>
<style lang="scss">
  .f-c-check {
    line-height: 24px;
    display: flex !important;
    align-items: center;
    position: relative;

    .el-checkbox__input {
      width: 24px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
    }

    .el-checkbox__inner {
      width: 16px;
      height: 16px;

      &:after {
        left: 5px;
        top: 2px;
      }
    }

    .el-checkbox__label {
      font-size: 14px;
      font-weight: normal;
      flex: 1;
      white-space: normal;
    }
  }
</style>
